interface TreeDictionary {
  name: string;
  plural: string;
  type: string;
  urlName: string;
  lowercaseName: string;
}

export enum TreeTypes {
  EVENT_TREE = 'e',
  FAULT_TREE = 'f',
  BAYESIAN_NETWORK = 'b',
  MANAGEMENT_FAULT_TREE = 'm'
}

const EventTreeDictionary: TreeDictionary = {
  name: 'Event Sequence',
  plural: 'Event Sequences',
  type: TreeTypes.EVENT_TREE,
  urlName: 'event-sequence',
  lowercaseName: 'event sequence',
};

const FaultTreeDictionary: TreeDictionary = {
  name: 'Fault Tree',
  plural: 'Fault Trees',
  type: TreeTypes.FAULT_TREE,
  urlName: 'fault-tree',
  lowercaseName: 'fault tree',
};

const BayesianNetworkDictionary: TreeDictionary = {
  name: 'Bayesian Network',
  plural: 'Bayesian Networks',
  type: TreeTypes.BAYESIAN_NETWORK,
  urlName: 'bayesian-network',
  lowercaseName: 'bayesian network',
};

export enum TreeNames {
  EVENT_TREE = 'event-sequence',
  FAULT_TREE = 'fault-tree',
  BAYESIAN_NETWORK = 'bayesian-network'
}

export const TreeTypeDictionary = {
  [TreeTypes.EVENT_TREE]: TreeNames.EVENT_TREE,
  [TreeTypes.FAULT_TREE]: TreeNames.FAULT_TREE,
  [TreeTypes.BAYESIAN_NETWORK]: TreeNames.BAYESIAN_NETWORK,
};

const TreeDictionaries = {
  [TreeNames.EVENT_TREE]: EventTreeDictionary,
  [TreeNames.FAULT_TREE]: FaultTreeDictionary,
  [TreeNames.BAYESIAN_NETWORK]: BayesianNetworkDictionary,
};

export default TreeDictionaries;
